import React from 'react';

import {Col, Row} from 'react-bootstrap';

import * as IconFi from 'react-icons/fi';

import './Steps.scss'

const Steps = props => {

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <Row className="pt-3 pb-4">
            {
                Array.from({length: props.stepsTotal}).map((_, index) => {
                    return (
                        <Col key={index} className={`position-relative d-flex justify-content-center${index === 0 ? ' first' : index === (props.stepsTotal - 1) ? ' last' : ''}${props.step === index + 1 ? ' current' : ''}`}>
                            <div className={`d-flex justify-content-center align-items-center rounded-circle ${index < props.step ? 'bg-accent' : 'bg-white bg-opacity-12'}`}>
                                <IconFi.FiCheck size={12} className="text-light"/>
                            </div>
                        </Col>
                    )
                })
            }
        </Row>
    )
}

export default Steps;